// assets
import { IconFlame } from '@tabler/icons';

// ==============================|| HAUNTED HOUSE SPECIAL EVENT MENU ITEM ||============================== //

const haunted = {
  id: 'haunted',
  title: 'Special Event',
  type: 'group',
  children: [
    {
      id: 'haunted-house',
      title: 'Haunted House 🎃',
      type: 'item',
      url: '/haunted',
      icon: IconFlame,
      breadcrumbs: false
    }
  ]
};

export default haunted;
